/**
 * Primary site navigation — single source for header, mobile sheet, and footer.
 *
 * Dedicated submission routes live under `/submit/*`. `/production-network` is
 * the canonical crew route. Items in HIDDEN_NAV_LINKS are intentionally omitted
 * from visible nav so they can be restored later without recreating structure.
 */

export const PRODUCTION_NETWORK_PATH = "/production-network";
/** Legacy path retained as a client redirect to the canonical route. */
export const PRODUCTION_NETWORK_LEGACY_PATH = "/crew";

export const PROJECTS_PATH = "/projects";
export const PRESS_PATH = "/press";
export const SUBMIT_HUB_PATH = "/submit";

export const NAV_LINKS = [
  { label: "Home", to: "/", hash: "home" },
  { label: "About", to: "/", hash: "about" },
  { label: "Projects", to: PROJECTS_PATH },
  { label: "Casting", to: "/submit/talent", formHash: "talent-submission-form" },
  {
    label: "Crew & Production Submission",
    to: PRODUCTION_NETWORK_PATH,
    formHash: "crew-production-submission-form",
  },
  { label: "Partner With SoKno", to: "/submit/partner", formHash: "partner-form" },
  { label: "Contact", to: "/submit/contact", formHash: "general-inquiry-form" },
];

/** Secondary footer links (not primary nav). */
export const FOOTER_EXTRA_LINKS = [
  { label: "Connect With SoKno", to: SUBMIT_HUB_PATH },
  { label: "Privacy", to: "/privacy" },
];

/** Kept for restore — do not render in primary navigation. */
export const HIDDEN_NAV_LINKS = [
  { label: "Production Circle", to: "/", hash: "production-circle" },
  // Press route retained; restore to FOOTER_EXTRA_LINKS when press room has fuller assets.
  { label: "Press", to: PRESS_PATH },
  // Upcoming Announcements section was removed; restore when content returns.
  { label: "Upcoming Announcements", to: "/", hash: "announcements" },
];

export function navTestId(label, prefix = "nav-link") {
  return `${prefix}-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/g, "")}`;
}

export function linkHref(link) {
  if (link.hash) return `${link.to}#${link.hash}`;
  if (link.formHash) return `${link.to}#${link.formHash}`;
  return link.to;
}

export function isProductionNetworkPath(pathname) {
  return pathname === PRODUCTION_NETWORK_PATH;
}
